import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FuelParameterConfig } from 'src/redux/slices/analysis/consts'
import { updateFuelScenarioSettings } from 'src/redux/slices/analysis/reducers'
import { makeSelectFuelSettings } from 'src/redux/slices/analysis/selectors'
import { UpdateFuelScenarioSettingsPayload } from 'src/redux/slices/analysis/types'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import TextField from '@material-ui/core/TextField'

type ScenarioFuelParameterProps = Omit<UpdateFuelScenarioSettingsPayload['payload'], 'value'>

const ScenarioFuelParameter: React.FC<ScenarioFuelParameterProps> = ({
  scenarioName,
  parameterKey,
  fuelSource,
}) => {
  const value = useSelector(makeSelectFuelSettings(scenarioName, parameterKey, fuelSource))
  const config = useMemo(() => FuelParameterConfig[parameterKey], [parameterKey])
  const dispatch = useDispatch()
  const handleChange = useCallback(
    (e: TextFieldOnChangeEvent) => {
      dispatch(
        updateFuelScenarioSettings({
          scenarioName,
          parameterKey,
          fuelSource,
          value: Number(e.target.value),
        }),
      )
    },
    [dispatch, updateFuelScenarioSettings],
  )
  return (
    <TextField
      label={`${config.label}`}
      variant='outlined'
      type='number'
      InputProps={{
        inputProps: {
          min: config.min,
          max: config.max,
          step: config.step,
        },
      }}
      value={value}
      helperText={config.units}
      onChange={handleChange}
    />
  )
}

export default ScenarioFuelParameter
